<template>
  <div class="ReviewCarousel">
    <UICarousel :items="reviews">
      <template #card="{ item }">
        <ReviewCard
          :logoHeight="asReviewItem(item).logoHeight"
          :rating="asReviewItem(item).rating"
          :name="asReviewItem(item).name"
          :jobTitle="asReviewItem(item).jobTitle"
          :companyLogoKey="asReviewItem(item).companyLogoKey"
          :class="cardClasses(asReviewItem(item))"
        >
          <template #text>
            {{ asReviewItem(item).text }}
          </template>
        </ReviewCard>
      </template>
    </UICarousel>
  </div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue'
import ReviewCard from '@/views/components/cards/ReviewCard.vue'
import UICarousel from '@/views/components/UICarousel.vue'
import {
  REVIEW_CAROUSEL_DEFAULTS,
  type ReviewCarouselItem,
} from './reviewCarousel.shared'

export type { ReviewCarouselItem } from './reviewCarousel.shared'

const props = defineProps({
  reviews: Array as PropType<ReviewCarouselItem[]>,
})

const asReviewItem = (value: unknown): ReviewCarouselItem =>
  value as ReviewCarouselItem

const cardClasses = (review: ReviewCarouselItem) =>
  [
    'ReviewCarousel__card',
    review.size ? `ReviewCarousel__card--${review.size}` : null,
  ].filter(Boolean)

const reviews = computed(() => props.reviews ?? REVIEW_CAROUSEL_DEFAULTS)
</script>

<style lang="scss" scoped>
.ReviewCarousel {
  width: 100%;
  min-width: 0;

  :deep(.UICarousel) {
    width: 100%;
    max-height: 100%;
    min-height: 0;
  }

  :deep(.UICarousel__controls) {
    justify-content: flex-end;
  }

  .ReviewCarousel__card {
    width: 100%;

    @include md {
      width: 26.5rem;
    }
  }

  .ReviewCarousel__card--sm {
    @include md {
      width: 20rem;
    }
  }

  .ReviewCarousel__card--md {
    @include md {
      width: 23.75rem;
    }
  }

  .ReviewCarousel__card--lg {
    @include md {
      width: 34.25rem;
    }
  }

  .ReviewCarousel__card--xl {
    @include md {
      width: 40.25rem;
    }
  }
}
</style>
